import { IsNumber, IsOptional, IsString, IsUUID } from 'class-validator'
import { ApiPropertyOptional } from '@nestjs/swagger'

export class UpdateTeachingStaffDto {
  @ApiPropertyOptional({ type: 'string', description: "ID de l'enseignement" })
  @IsOptional()
  @IsString()
  teachingId?: string

  @ApiPropertyOptional({ type: 'string', description: "ID de l'utilisateur enseignant" })
  @IsOptional()
  @IsString()
  teacherUserId?: string

  @ApiPropertyOptional({ type: 'string', description: 'ID du rôle' })
  @IsOptional()
  @IsUUID('4')
  roleId?: string

  @ApiPropertyOptional({ type: Number, description: 'Part de charge de travail' })
  @IsOptional()
  @IsNumber()
  workloadShare?: number
}